import "./ClientInfo.scss";
import { useAppSelector } from "store";

const ClientInfo = () => {
  const profileInfo = useAppSelector((state) => state.cabinet);
  const className = () => {
    switch (profileInfo.kycStatus) {
      case "approved":
        return "client-info-value green-status";
      case "failed":
        return "client-info-value red-status";
      case "processing":
        return "client-info-value yellow-status";
      default:
        return "client-info-value";
    }
  };
  return (
    <div className="client-info-container">
      <div className="client-info-row">
        <div className="client-info-field">First Name</div>
        <div className="client-info-value">{profileInfo.firstName}</div>
      </div>
      <div className="client-info-row">
        <div className="client-info-field">Last Name</div>
        <div className="client-info-value">{profileInfo.lastName}</div>
      </div>
      <div className="client-info-row">
        <div className="client-info-field">Email</div>
        <div className="client-info-value">{profileInfo.email}</div>
      </div>
      <div className="client-info-row">
        <div className="client-info-field">Country</div>
        <div className="client-info-value">{profileInfo.country}</div>
      </div>
      <div className="client-info-row">
        <div className="client-info-field">Verification status</div>
        <div className={className()}>{profileInfo.kycStatus}</div>
      </div>
    </div>
  );
};

export default ClientInfo;
